import { FETCH_DOWNLOAD_BATCH_STATUS_REQUEST, FETCH_DOWNLOAD_BATCH_STATUS_SUCCESS, FETCH_DOWNLOAD_BATCH_STATUS_FAILURE, FETCH_DOWNLOAD_BATCH_STATUS_RESET, } from "../../actions";
const initialState = {
    metaData: null,
    isLoading: false,
    error: null,
};
const checkBatchStatusReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_DOWNLOAD_BATCH_STATUS_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, metaData: null, error: null });
        case FETCH_DOWNLOAD_BATCH_STATUS_SUCCESS:
            return Object.assign(Object.assign({}, state), { metaData: action.payload, isLoading: false, error: null });
        case FETCH_DOWNLOAD_BATCH_STATUS_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: action.payload });
        case FETCH_DOWNLOAD_BATCH_STATUS_RESET:
            return Object.assign(Object.assign({}, state), { metaData: null, isLoading: true, error: null });
        default:
            return state;
    }
};
export default checkBatchStatusReducer;
